export default __webpack_public_path__ + "images/d77101fe6c2007bb5d8051690da97f75.gif";